import { observable, action, makeObservable } from 'mobx';

import { Nullable, Optional } from 'chaika-frontend-types/frontend-cms';

import { RightMenu, PageMode } from './RightMenu';
import { RightContentMenu } from './RightContentMenu';
import { PagesParams } from '@common/TabsNavigationPage';

export interface SelectedTableFieldParams {
    fieldName: string;
    cellName: string;
}

export class EntryPage {
    public static Name = 'entryPage' as const;

    @observable public rightMenu: RightMenu = new RightMenu();
    @observable public selectedTextField?: string;
    @observable public selectedTableField?: SelectedTableFieldParams;
    @observable public selectedFieldId?: string;
    @observable public selectedFieldCursorPosition?: number;
    @observable public isShortPrintForm = false;
    @observable public rightContentMenu: RightContentMenu = new RightContentMenu();
    @observable public onClickOutsideRightContent: Nullable<() => void> = null;
    @observable public rightContentOpen = false;

    @observable public activeTab?: PagesParams;

    @observable public isRedesign = false;

    constructor() {
        makeObservable(this);
    }

    public get pageMode(): Optional<PageMode> {
        return this.rightMenu.selectedIndex;
    }

    public set pageMode(pageMode: PageMode) {
        this.rightMenu.selectedIndex = pageMode;
        this.rightContentOpen = false;
    }

    @action
    public setActiveTab(activeTab: PagesParams) {
        this.activeTab = activeTab;
    }

    @action
    public setRedesign(isRedesign: boolean) {
        this.isRedesign = isRedesign;
    }

    @action
    public reset() {
        this.rightMenu = new RightMenu();
        this.rightContentMenu = new RightContentMenu();
        this.rightContentOpen = false;
        this.activeTab = undefined;
    }
}

export const entryPage = new EntryPage();
